import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import { Badge, IconButton, Drawer } from '@material-ui/core';
import Popper from 'components/Popper';
import servises, {
  useGetCustomerCartsQuery,
  useGetListCustomerGroupsQuery,
  useGetShoppingCartDetailsQuery,
} from 'core/services';

import { egg_broken } from 'assets';
import useIsLoading from 'hooks/useIsLoading.hook';
import useMobile from 'hooks/useMobile.hook';
import { getArray } from 'utils/helpers';

import CartMeta from 'views/CartMeta';
import CartSelect from 'views/CartSelect';
import CheckoutButton from 'views/CheckoutButton';

import Icon from 'components/Icon';
import ButtonIcon from 'components/IconButton';
import Button2 from 'components/Button2';
import Repeat from 'components/Repeat';
import Space from 'components/Space';

import CardItem from './CardItem';
import style from './style.module.scss';
import useSkipForProduct from 'hooks/useSkipForProduct.hook';

const { changeCart } = servises;

const ItemsList = () => {
  const cart_id = useSelector((state) => state.cart.cart_id);

  const labGroupsQuery = useGetListCustomerGroupsQuery();
  const skipForProduct = useSkipForProduct();
  const cartDetailsQuery = useGetShoppingCartDetailsQuery(
    { cart_id },
    {
      skip: skipForProduct || !cart_id,
    },
  );
  const cartDetails = cartDetailsQuery.data;
  const cartItems = getArray(cartDetails?.items);
  const loading = useIsLoading(cartDetailsQuery, labGroupsQuery);

  return (
    <>
      <div className={style.cardsList}>
        {!loading &&
          cartItems.map((item) => (
            <CardItem key={item.id} style={style} item={item} />
          ))}

        {!loading && cartItems.length === 0 && (
          <div className={style.empty}>
            <img src={egg_broken} alt="Not Found" />
            <b>Your cart is empty</b>
            <span>Please add product</span>
          </div>
        )}

        {loading && (
          <Space direction="column" fullWidth>
            <Repeat times={3}>
              <Space
                direction="column"
                width="100%"
                alignItems="flex-start"
                pb={3}
              >
                <Space width="100%" justifyContent="space-between">
                  <Skeleton variant="text" width="100%" />

                  <Space>
                    <Skeleton variant="rect" width={20} height={20} />
                    <Skeleton variant="rect" width={20} height={20} />
                  </Space>
                </Space>

                <Skeleton variant="text" width="100%" />
                <Skeleton variant="text" width="50%" />
              </Space>
            </Repeat>
          </Space>
        )}
      </div>

      {cartItems.length > 0 && (
        <div className={style.checkout}>
          <CheckoutButton width={190} />
        </div>
      )}
    </>
  );
};

const ItemsBadge = (props) => {
  const { onClick } = props;
  const skipForProduct = useSkipForProduct();
  const cart_id = useSelector((state) => state.cart.cart_id);
  const cartsQuery = useGetCustomerCartsQuery(undefined, {
    skip: skipForProduct,
  });
  const cartDetailsQuery = useGetShoppingCartDetailsQuery(
    { cart_id },
    {
      skip: skipForProduct || !cart_id,
    },
  );
  const carts = getArray(cartsQuery.data);
  const cartDetails = cartDetailsQuery.data;
  const loading = useIsLoading(cartsQuery, !cart_id);

  useEffect(() => {
    if (carts.length > 0 && !cart_id) {
      changeCart(carts[0].id);
    }
  }, [carts, cart_id]);

  const CartIcon =
    cartDetails?.cart_total_items > 0 ? Icon.EggFull : Icon.EggEmpty;

  return (
    <Badge
      color="primary"
      overlap="rectangular"
      className={style.badge}
      badgeContent={cartDetails?.cart_total_items}
    >
      <ButtonIcon onClick={onClick} loading={loading}>
        {!loading && <CartIcon />}
      </ButtonIcon>
    </Badge>
  );
};

const CardList = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isMobile = useMobile();

  const cart_id = useSelector((state) => state.cart.cart_id);
  const skipForProduct = useSkipForProduct();
  const cartDetailsQuery = useGetShoppingCartDetailsQuery(
    { cart_id },
    {
      skip: skipForProduct || !cart_id,
    },
  );

  const handleTogglePopper = (event) => {
    setAnchorEl((prev) => (prev ? null : event.currentTarget));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <ItemsBadge onClick={handleTogglePopper} />

      {!isMobile && (
        <Popper open={open} anchorEl={anchorEl} onClose={handleClose}>
          <div className={style.wrapper}>
            <div className={style.header}>
              <div className={style.cartActions}>
                <CartSelect />

                <Button2
                  variant="string"
                  component={Link}
                  to="/cart"
                  size="medium"
                  className={style.viewCartButton}
                >
                  View Cart
                </Button2>
              </div>

              <div className={style.cartMeta}>
                <CartMeta cart={cartDetailsQuery.data} />
              </div>
            </div>

            <ItemsList />
          </div>
        </Popper>
      )}

      {isMobile && (
        <Drawer open={open} anchor="left">
          <div className={style.wrapper}>
            <div className={style.header}>
              <div className={style.closeButtonContainer}>
                <IconButton
                  size="small"
                  onClick={handleClose}
                  className={style.closeButton}
                >
                  <Icon.Close />
                </IconButton>
              </div>

              <div className={style.cartSelectMobile}>
                <CartSelect />

                <div className={style.cartActionsMobile}>
                  <CartMeta cart={cartDetailsQuery.data} />
                  <Button2
                    variant="string"
                    component={Link}
                    to="/cart"
                    size="medium"
                  >
                    View Cart
                  </Button2>
                </div>
              </div>
            </div>

            <ItemsList />
          </div>
        </Drawer>
      )}
    </>
  );
};

export default CardList;
